<div class="roster-export-dialog">
  <div class="dialog-header">
    <h2>Export Roster</h2>
    <button mat-icon-button (click)="onCancel()" class="close-btn">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-dialog-content class="dialog-content">
    <p class="subtitle-text">Select the export format and content type:</p>
    
    <mat-radio-group [(ngModel)]="selectedType" class="export-radio-group">
      <div *ngFor="let type of filteredExportTypes" class="export-option-row" [class.selected]="selectedType === type.value" (click)="selectedType = type.value">
        <mat-radio-button [value]="type.value" color="primary" (click)="$event.stopPropagation()">
          <span class="option-label">{{ type.label }}</span>
        </mat-radio-button>
      </div>
    </mat-radio-group>
  </mat-dialog-content>

  <div class="dialog-actions">
    <button mat-button (click)="onCancel()" class="cancel-btn">CANCEL</button>
    <button mat-flat-button color="primary" (click)="onApply()" class="apply-btn">EXPORT</button>
  </div>
</div>
